import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { SPONSORS } from "./sponsors.js";
import { SUPPORT_PATH, SUPPORT_SUBPAGE_PATH } from "../../pages/Support/paths.js";

/** Flat sponsor logo wall for Home — the tiered version lives in SponsorShowcase.jsx (Über uns). */
export default function SponsorLogos({ lang }) {
  const { t } = useTranslation();

  if (SPONSORS.length === 0) return null;

  return (
    <section style={{ display: "flex", flexDirection: "column", gap: "24px" }}>
      <div style={{ display: "flex", alignItems: "baseline", justifyContent: "space-between", gap: "24px", flexWrap: "wrap" }}>
        <span style={{ fontSize: "11px", letterSpacing: "0.2em", textTransform: "uppercase", color: "var(--color-gold)" }}>
          {t("sponsors.homeEyebrow")}
        </span>
        <Link
          to={`/${lang}/${SUPPORT_PATH[lang]}/${SUPPORT_SUBPAGE_PATH.sponsoring[lang]}`}
          style={{ fontSize: "13px", color: "var(--color-cream-soft)" }}
        >
          {t("sponsors.becomePartnerLink")}
        </Link>
      </div>
      <div className="tl-grid-3" style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "20px" }}>
        {SPONSORS.map((sponsor) => (
          <a
            key={sponsor.name}
            href={sponsor.url}
            target="_blank"
            rel="noopener noreferrer"
            title={sponsor.name}
            className="tl-sponsor-logo"
            style={{ justifyContent: "center", minHeight: "96px" }}
          >
            <img
              src={sponsor.logo}
              alt={sponsor.name}
              loading="lazy"
              decoding="async"
              width={sponsor.logoWidth}
              height={44}
              // object-fit keeps the mark undistorted when max-width has to crush the
              // box on a narrow screen: without it the image kept its 44px height
              // while the width was squeezed from 221px to 80px.
              style={{ height: "44px", width: "auto", maxWidth: "100%", objectFit: "contain" }}
            />
          </a>
        ))}
      </div>
    </section>
  );
}
